import React, { useState } from 'react'
import styles from './consent_banner.module.scss'

const STORAGE_KEY = 'consent'
const TWELVE_MONTHS_SECONDS = 365 * 24 * 60 * 60

function hasValidDecision() {
  const value = getConsentCookie()
  const entry = getLocalStorageEntry()

  // If there is a consent cookie, GREAT! Lets use it.
  if (value === 'accepted' || value === 'declined') {
    if (!entry || entry.expires <= Date.now()) {
      // If there's a consent cookie and no localStorage entry
      // lets set it.
      setLocalStorageEntry(value)
    }
    return true
  }
  // If there is no consent cookie and there is a local storage item (that isn't expired)
  // lets _fix_ the cookie by using localStorage's values.
  if (entry && entry.expires > Date.now()) {
    const remainingSeconds = Math.floor((entry.expires - Date.now()) / 1000)
    console.log('Consent LS existed but cookie did not.')
    setConsentCookie(entry.decision, remainingSeconds)
    return true
  }
  // if there is no localStorage nor consent cookie then we do not know what decision has
  // been made.
  return false
}

function getConsentCookie() {
  const match = document.cookie.match(new RegExp('(?:^|; )' + STORAGE_KEY + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : null
}

function getLocalStorageEntry() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

function setLocalStorageEntry(decision, time=TWELVE_MONTHS_SECONDS) {
  const entry = { decision, expires: Date.now() + time * 1000 }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(entry))
}

function setConsentCookie(decision, time=TWELVE_MONTHS_SECONDS) {
  document.cookie = `${STORAGE_KEY}=${encodeURIComponent(decision)}; max-age=${time}; path=/; SameSite=Lax`
}

function storeDecision(decision) {
  setLocalStorageEntry(decision)
  setConsentCookie(decision)
}

export default function ConsentBanner() {
  const [visible, setVisible] = useState(() => !hasValidDecision())

  if (!visible) return null

  function handleAccept() {
    storeDecision('accepted')
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted'
      })
    }
    setVisible(false)
  }

  function handleDecline() {
    storeDecision('declined')
    setVisible(false)
  }

  return (
    <div className={styles.banner} role="dialog" aria-label="Cookie consent">
      <div className={styles.inner}>
        <p className={styles.text}>
          We use cookies to personalize your experience and for marketing purposes.
          By clicking &ldquo;Accept&rdquo; you consent to our use of tracking cookies.
          See our <a href="/privacy-policy" className={styles.link}>Privacy Policy</a> for more information.
        </p>
        <div className={styles.actions}>
          <button className='button highlighted' onClick={handleAccept}>
            Accept
          </button>
          <button className='button light-button' onClick={handleDecline}>
            Decline
          </button>
        </div>
      </div>
    </div>
  )
}
